<template>
  <v-card class="pa-4">
    <p class="home-section-title">Conferences</p>
    <p>
      BugSeq will be attending/sponsoring the following conferences. If you will be attending any of these, please <a href="mailto:contact@bugseq.com?subject=Conference Inquiry&body=Hi! I'd like to meet up at a conference you will be attending...">reach out</a> as we would love to schedule time to meet.
    </p>
    <v-container
      v-for="(conference, index) in conferences"
      :key="index"
    >
      <v-layout row wrap>
        <v-flex xs12 sm3>
          <a :href="conference.href" target="_blank">
            <v-img
              :src="conference.image"
              class="conferenceimg"
            ></v-img>
          </a>
        </v-flex>
        <v-flex xs12 sm9 class="pl-4">
          <div class="title mb-3">{{conference.name}}</div>
          <div class="my-2"><v-icon class="mr-2">date_range</v-icon>{{conference.dates}}</div>
          <div class="my-2"><v-icon class="mr-2">place</v-icon>{{conference.location}}</div>
          <div v-if="conference.detailsPage" class="mt-3">
            <v-btn
              :to="conference.detailsPage"
              color="primary"
              small
              outlined
            >
              <v-icon left small>info</v-icon>
              BugSeq Events & Schedule
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import ImgSHEA from "@bugseq-site/www/src/assets/img/resources/conferences/2026/shea.webp";
import ImgESCMID from "@bugseq-site/www/src/assets/img/resources/conferences/2026/escmid.webp";
import ImgPASCV from "@bugseq-site/www/src/assets/img/resources/conferences/2026/pascv.png";
import ImgAPHL from "@bugseq-site/www/src/assets/img/resources/conferences/2026/aphl.webp";
import ImgLC from "@bugseq-site/www/src/assets/img/resources/conferences/2026/london-calling.webp";
import ImgASM from "@bugseq-site/www/src/assets/img/resources/conferences/2026/asm-microbe.webp";
import ImgIAFP from "@bugseq-site/www/src/assets/img/resources/conferences/2026/iafp.webp";
import ImgASMBig from "@bugseq-site/www/src/assets/img/resources/conferences/2026/asm-big.webp";
import ImgIDWeek from "@bugseq-site/www/src/assets/img/resources/conferences/2026/idweek.webp";
import ImgAMP from "@bugseq-site/www/src/assets/img/resources/conferences/2026/amp.webp";

export default {
  metaInfo: {
    title: "Conferences",
    titleTemplate: "BugSeq | %s",
  },
  data() {
    return {
      conferences: [
        {
          name: "SHEA Spring 2026",
          dates: "April 7-10, 2026",
          location: "Chicago, IL",
          image: ImgSHEA,
          href: "https://sheaspring.org/",
        },
        {
          name: "ESCMID Global 2026 (Booth H11)",
          dates: "April 17-21, 2026",
          location: "Munich, DE",
          image: ImgESCMID,
          href: "https://www.escmid.org/congress-events/escmid-global/",
        },
        {
          name: "PASCV 2026 (Booth 02T)",
          dates: "April 29-May 1, 2026",
          location: "Clearwater, FL",
          image: ImgPASCV,
          href: "https://www.pascv.org/page/2026_Annual_Meeting",
        },
        {
          name: "APHL 2026 (Booth 200)",
          dates: "May 4-7, 2026",
          location: "Baltimore, MD",
          image: ImgAPHL,
          href: "https://www.aphl.org/conferences/annualmeeting/Pages/default.aspx",
        },
        {
          name: "London Calling 2026",
          dates: "May 19-21, 2026",
          location: "London, UK",
          image: ImgLC,
          href: "https://nanoporetech.com/about/events/conferences/lc26",
        },
        {
          name: "ASM Microbe 2026 (Booth 2206)",
          dates: "June 4-7, 2026",
          location: "Washington, D.C.",
          image: ImgASM,
          href: "https://asm.org/events/asm-microbe/home",
          detailsPage: "/resources/conferences/asm-microbe-2026",
        },
        {
          name: "IAFP 2026",
          dates: "July 26-29, 2026",
          location: "New Orleans, LA",
          image: ImgIAFP,
          href: "https://www.foodprotection.org/",
        },
        {
          name: "ASM BIG 2026",
          dates: "October 11-14, 2026",
          location: "Washington, D.C.",
          image: ImgASMBig,
          href: "https://asm.org/events/asm-big/home",
        },
        {
          name: "IDWeek 2026",
          dates: "October 21-24, 2026",
          location: "Washington, D.C.",
          image: ImgIDWeek,
          href: "https://www.idweek.org/",
        },
        {
          name: "AMP 2026",
          dates: "November 2026",
          location: "Seattle, WA",
          image: ImgAMP,
          href: "https://amp26.amp.org/",
        },
      ],
    }
  },
};
</script>

<style scoped>
.conferenceimg {
  border-radius: 5px;
}
</style>
